import React from "react";
import styled from "styled-components";
import { customerLogos } from "../Data/websiteUpdates";

const LogoGrid = () => (
  <SectionWrapper aria-labelledby="customer-logo-heading">
    <div className="container" style={{ width: "100%" }}>
      <SectionLabel>Our Customers</SectionLabel>
      <LogoHeading id="customer-logo-heading">Trusted by innovators &amp; leaders</LogoHeading>
      <Grid>
        {customerLogos.map((logo, index) => (
          <LogoWrapper key={`${logo.name}-${index}`}>
            <StyledImage src={logo.src} alt={logo.name} loading="lazy" />
          </LogoWrapper>
        ))}
      </Grid>
    </div>
  </SectionWrapper>
);

export default LogoGrid;

const SectionWrapper = styled.section`
  padding: 8rem 0 4rem;
  display: flex;
  justify-content: center;
  background-color: #fff;

  @media (max-width: 600px) {
    padding: 5rem 0 2.5rem;
  }
`;

const SectionLabel = styled.p`
  margin-bottom: 0.5rem;
  color: #9b1ea4;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
`;

const LogoHeading = styled.h2`
  margin-bottom: 2.2rem;
  color: #1f2fa8;
  font-size: 2.2rem;
  font-weight: 600;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 3rem;
  align-items: center;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 2rem 2.5rem;
    padding: 0 1rem;
  }
`;

const LogoWrapper = styled.div`
  width: 100%;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledImage = styled.img`
  max-width: 100%;
  max-height: 70px;
  object-fit: contain;
  display: block;
`;
